module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.authenticated()) ? _c('h1', [_vm._v("Activated the profile...")]) : _c('div', [_vm._v("\n  Not authenticated\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1067df7f"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activated.vue
// module id = 537
// module chunks = 1